import { CSSProperties } from 'react'
import Colors from 'modules/Colors'

interface LeaveIconProps {
    className?: string
    style?: CSSProperties
    color?: string
    size?: number
    onClick?: () => void
}

const LeaveIcon = ({
    className,
    style,
    color = Colors.purple,
    size = 24,
    onClick
}: LeaveIconProps) => {
    return (
        <svg
            className={className}
            style={style}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
        >
            <path
                d="M9 12H19"
                stroke={color}
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M16 8L18.5858 10.5858C19.3668 11.3668 19.3668 12.6332 18.5858 13.4142L16 16"
                stroke={color}
                strokeWidth={2}
                strokeLinecap="round"
            />
            <path
                d="M16 4H6C4.89543 4 4 4.89543 4 6V18C4 19.1046 4.89543 20 6 20H16"
                stroke={color}
                strokeWidth={2}
                strokeLinecap="round"
            />
        </svg>
    )
}

export default LeaveIcon
